/* eslint-disable @typescript-eslint/naming-convention */
import type { TextStyle } from '@studiobuki/web-core/lib/book-common';

export const APJapanesefont_000000_18: TextStyle = {
  fill: '#000000',
  fontFamily: 'APJapanesefont',
  fontSize: 18,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const APJapanesefont_000000_24: TextStyle = {
  fill: '#000000',
  fontFamily: 'APJapanesefont',
  fontSize: 24,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const APJapanesefont_000000_16: TextStyle = {
  fill: '#000000',
  fontFamily: 'APJapanesefont',
  fontSize: 16,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const APJapanesefont_000000_20: TextStyle = {
  fill: '#000000',
  fontFamily: 'APJapanesefont',
  fontSize: 20,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const KozGoProRegular_000000_31: TextStyle = {
  fill: '#000000',
  fontFamily: 'KozGoProRegular',
  fontSize: 31,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const KozGoProRegular_000000_21: TextStyle = {
  fill: '#000000',
  fontFamily: 'KozGoProRegular',
  fontSize: 21,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const Wahupop_000000_24: TextStyle = {
  fill: '#000000',
  fontFamily: 'Wahupop',
  fontSize: 24,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const KaiseiOpti_000000_30: TextStyle = {
  fill: '#000000',
  fontFamily: 'Kaisei Opti',
  fontSize: 30,
  letterSpacing: 1,
  lineHeight: 1.5,
};

export const KozGoProBold_0b4561_30: TextStyle = {
  fill: '#0b4561 ',
  fontFamily: 'KozGoProBold',
  fontSize: 35,
  letterSpacing: 5,
  lineHeight: 1.5,
  stroke: '#ffffff',
  strokeWidth: 6,
  fillAfterStrokeEnabled: true,
};
export const KozGoProBold_0b4561_31: TextStyle = {
  fill: '#0b4561 ',
  fontFamily: 'KozGoProBold',
  fontSize: 40,
  letterSpacing: 5,
  lineHeight: 1.5,
  stroke: '#ffffff',
  strokeWidth: 6,
  fillAfterStrokeEnabled: true,
};
